module.exports = __webpack_public_path__ + "static/media/act04.25c1f9cf.mpeg";